<template>
  <v-select class="locale-select" :items="locales" item-text="label" item-value="code" v-model="hl" solo dense flat/>
</template>

<script>
import { defineComponent, inject, ref } from 'vue'
import {  getAvailableLocales  } from '../utils/language';

export default defineComponent({
  setup() {
    const hl = inject('hl');
    const locales = ref(getAvailableLocales());

    console.log(locales.value)

    return {
      locales,
      hl
    }
  },
})
</script>

<style lang="scss" scoped>
.locale-select ::v-deep {

  .v-text-field__details {
    display: none;
  }
  .v-label {
    font-size: .875rem;
  }
  .v-input__slot {
    transition: none;
    margin-bottom: 0;
  }
}
</style>